/**
 * Determine identity logout URL based on environment.
 * Detects production vs staging environment and constructs appropriate logout URL.
 *
 * @returns The constructed logout URL for the current environment
 */
export const getIdentityLogoutUrl = (): string => {
	const hostname = window.location.hostname;

	// Detect environment based on current domain
	const isProduction = hostname.includes('.atlassian.com') || hostname.includes('.atlassian.net');

	const identityBaseUrl = isProduction
		? 'https://id.atlassian.com'
		: 'https://id.stg.internal.atlassian.com'; // Default to staging for dev/staging environments

	const continueUrl = encodeURIComponent(window.location.href);
	return `${identityBaseUrl}/logout?prompt=none&continue=${continueUrl}`;
};
